import { DonationsContainer } from 'containers/Donations'

export default DonationsContainer
